export default __webpack_public_path__ + "bfa6f3f61d4c6ecf9fab0236c3d1452b.png";